import React, { useEffect } from 'react';
import { useState } from 'react';
import App from '../App';
import { insights } from '../data/Insights';
import FeedbackPopUp from './FeedbackPopUp';
import Cookie from './Cookie';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { initReactI18next, useTranslation } from 'react-i18next';
import { Routes, Route, useLocation } from 'react-router-dom';
import i18n from './i18n';
import Embed from './Embed.js';

export default function IntroPage () {
	// Set the vars for translations.
	const { t } = useTranslation('survey');

	function shuffleArray (arr) {
		return arr.sort(() => Math.random() - 0.5);
	}

	// Set theInsights as the data.js by default.
	let theInsights = insights;
	// If defined in the index.html as window.insights then load from there
	if (window.insights) {
		theInsights = window.insights;
	}

	let stepQuestion;

	// Shuffle questions
	theInsights.structure.forEach((obj) => {
		if (obj.view === 'steps' || obj.view === 'questions') {
			stepQuestion = obj.view;
			if (stepQuestion) {
				obj.props[stepQuestion].forEach(
					(q) => {
						if ((q.type === 'choice' || q.type === 'order') && q.shuffle) {
							q.answers = shuffleArray(q.answers);
						}
					}
				);
			}
		}
	});

	// to show the questions
	const [show, setShow] = useState(false);
	const [feedbackUse, setFeedbackUse] = useState(false);
	const [embedded, setEmbedded] = useState(false);
	const [isclosed, setIsclosed] = useState(false);

	// submit progress
	const handleProgressSubmit = (questionNumber) => {
		theInsights ? theInsights.actions.progress(questionNumber) : console.log('no insights data');
	};

	const embeddedPanelHeight = (where) => {
		// Calculate the height with a 20px buffer.
		let heightTotal = Math.ceil(document.querySelector('.embedded #root').offsetHeight) + 20;
		// Post to the window.
		window.parent.postMessage('height:' + heightTotal, '*');
	};

	useEffect(() => {
		handleProgressSubmit('Welcome');
		if (theInsights.status === 'closed') {
			setIsclosed(true);
		}
	}, []);

	const handleShowClick = () => {
		setShow(true);
	};

	// Add the interaction url click
	document.addEventListener('click', function (event) {
		// If it's a link that's been clicked
		if (event.target.matches('a') || event.target.closest('a')) {
			// Work out what the <a> is
			var theatag = event.target.closest('a');
			if (event.target.matches('a')) {
				theatag = event.target;
			}
			if (!theatag.classList.contains('internal') && !theatag.classList.contains('follow')) {
				// Stop if following the link
				event.preventDefault();
				event.stopPropagation();
				event.stopImmediatePropagation();
				// Check some attributes
				var currentHost = window.location.hostname;
				var linkUrl = theatag.href;
				var linkText = theatag.innerText; // The text of the <a> by default.
				// Call the interaction
				theInsights.actions.interaction('url click', linkUrl, linkText);
				// Add a blank
				theatag.setAttribute('target', '_blank');
				// Then follow the link via adding a class & .click
				theatag.classList.add('follow');
				theatag.click();
			}
		}
	});

	// Get the size of the image...
	// https://stackoverflow.com/a/11442850
	const getMeta = async (url) => {
		const img = new Image();
		img.src = url;
		await img.decode();
		return img;
	};
	// ... then set the size based on even areas
	if (insights.structure[0].props.logo_url) {
		getMeta(insights.structure[0].props.logo_url).then(img => {
			const maxArea = 90000; // The max area in pixels
			// Set the logo width, this grabs the image, works out the size and scales it down so they're all the same area.
			// Maths: image width, divided by the square root of the area (width * height), divided by the max area. Then rounded up to the nearest whole number
			// Example, a 600x400 image is 240,000 pixels, divided by the max area is 16, the square root of that is 4, and dividing the image width is 600 / 4 = 150
			document.documentElement.style.setProperty('--logo-width', Math.ceil(img.naturalWidth / Math.sqrt((img.naturalWidth * img.naturalHeight) / maxArea)) + 'px');
			document.documentElement.style.setProperty('--logo-aspect', Math.ceil(img.naturalWidth / img.naturalHeight) + '/1');
		});
	}

	// pop function to open feedback pop up
	const feedbackPop = () => {
		setFeedbackUse(true);
		if (setFeedbackUse) {
			const element = document.getElementsByClassName('modal')[0];
			element.classList.add('modal-popup');
			// const IntroHeader = document.getElementsByClassName('intro_header')[0];
			// IntroHeader.style.display = 'none';
		}
	};

	return (
		<>
			<Routes>
				<Route path="/embed/" element={<Embed embedded={embedded} setEmbedded={setEmbedded} insights={theInsights} embeddedPanelHeight={embeddedPanelHeight} />} />
			</Routes>
			{ isclosed ? (
				<div className="survey survey--closed">
					<main className="survey__panel survey__panel--full modal">
						<div className="survey__intro">
							{theInsights.structure.map((str) => {
								if (str.view === 'welcome') {
									return (
										<div className="survey__logo">
											<img src={str.props.logo_url} alt=""/>
										</div>
									);
								}
								if (str.view === 'thanks') {
									return (
										<div>
											<h1>Survey closed</h1>
											<p>Thanks for taking part, checkback for other surveys.</p>
											<br />
											{(str.props.more_url && str.props.more_url !== '') ? <a className="button" target="_blank" rel="noopener noreferrer" href={str.props.more_url}>{t('survey.phrases.more')}</a> : null}
										</div>
									);
								}
							})}
						</div>
					</main>
				</div>
			) : '' }
			{(!show && !embedded && !isclosed) && (
				<div className="survey">
					{theInsights.structure.map((str) => {
						if (str.view === 'welcome') {
							return (
								<main className="survey__panel survey__panel--full modal">
									<div className="survey__intro" key={str.view}>
										<div className="survey__logo">
											<img src={str.props.logo_url} alt=""/>
										</div>
										<h1>{str.props.title}</h1>
										<div className="markdown">
											<Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{str.props.description}</Markdown>
										</div>
									</div>
									<div className="survey__cta">
										<button onClick={handleShowClick}>{t('survey.intro.start')}</button>
										{!feedbackUse && (<button className="open_popup plain" onClick={feedbackPop}>{t('survey.intro.how')}</button>)} {feedbackUse && (<FeedbackPopUp setFeedbackUse={setFeedbackUse} clientName={str.props.client_name} clientEmail={str.props.client_email} clientPhone={str.props.client_phone} clientPrivacy={str.props.client_privacy} setShow={setShow}/>)}
									</div>
								</main>
							);
						}
					})}
				</div>
			)}
			{(show || embedded && !isclosed) && (<App theInsights={theInsights} stepQuestion={stepQuestion} setShow={setShow} handleProgressSubmit={handleProgressSubmit} embedded={embedded} embeddedPanelHeight={embeddedPanelHeight}/>)}
			<Cookie/>
		</>
	);
}
